/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.userDelete.internal

import kangaroorewards.appsdk.core.io.EmptyResponse
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class UserDeleteServiceImpl : UserDeleteService {

    private val userDeleteRequest = UserDeleteRequest()

    override suspend fun deleteUserAccount(
        overrideHeaders : Map<String, String>?,
    ): Result<EmptyResponse> {
        return userDeleteRequest.deleteUserAccount(
            overrideHeaders = overrideHeaders,
        ).toModel()
    }
}
